import { useRef, useState } from "react";
import { Link } from "react-router";
import useOnClickOutside from "../../SharedModule/hooks/useOnClickOutside";
import { ReactComponent as More } from "../../SharedModule/svg/ic-more.svg";

export const ProductActions = (props: any) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Call hook passing in the ref and a function to call on outside click
  useOnClickOutside(dropdownRef, () => {
    setOpen(false);
  });

  const toggleSpotlight = () => {
    props.toggleHandler();
    setOpen(false);
  };

  return (
    <div className="position-relative">
      <More
        style={{ cursor: "pointer", margin: "25% 0 0 5%" }}
        onClick={() => setOpen((state: any) => !state)}
      />
      <div className={`dropdown-menu ${open ? "show" : ""}`} ref={dropdownRef}>
        {props.isLogged && props.isContentEditable && props.isProductActive && (
          <div
            onClick={() => toggleSpotlight()}
            className="dropdown-item pointer"
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                toggleSpotlight();
              }
            }}
          >
            {props.isSpotlightOn ? "Turn Off Spotlight" : "Turn On Spotlight"}
          </div>
        )}
        <Link
          className="dropdown-item"
          to={`/products/${props.productId}/spotlightHistory`}
        >
          Status History
        </Link>
      </div>
    </div>
  );
};
